(() => {
  if (window.mintFaqAnimationInitialized) return;

  window.mintFaqAnimationInitialized = true;

  const duration = 350;
  const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';
  const animations = new WeakMap();

  const stopAnimation = (details) => {
    const animation = animations.get(details);

    if (animation) {
      animation.cancel();
      animations.delete(details);
    }

    details.style.height = '';
    details.style.overflow = '';
  };

  const animateOpen = (details) => {
    const summary = details.querySelector('.mint-faq__question');
    if (!summary) return;

    stopAnimation(details);

    const startHeight = summary.offsetHeight;
    details.style.height = `${startHeight}px`;
    details.style.overflow = 'hidden';
    details.open = true;

    const endHeight = details.scrollHeight;
    const animation = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration, easing },
    );

    animations.set(details, animation);
    animation.onfinish = () => {
      details.style.height = '';
      details.style.overflow = '';
      animations.delete(details);
    };
  };

  const animateClose = (details) => {
    const summary = details.querySelector('.mint-faq__question');
    if (!summary) return;

    stopAnimation(details);

    const startHeight = details.offsetHeight;
    const endHeight = summary.offsetHeight;
    details.style.height = `${startHeight}px`;
    details.style.overflow = 'hidden';

    const animation = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration, easing },
    );

    animations.set(details, animation);
    animation.onfinish = () => {
      details.open = false;
      details.style.height = '';
      details.style.overflow = '';
      animations.delete(details);
    };
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.mint-faq__question');
    if (!summary) return;

    const details = summary.parentElement;
    const section = summary.closest('.mint-faq');
    if (!section || !details?.classList.contains('mint-faq__item')) return;

    event.preventDefault();

    if (details.open) {
      animateClose(details);
      return;
    }

    section.querySelectorAll('.mint-faq__item[open]').forEach((item) => {
      if (item !== details) animateClose(item);
    });
    animateOpen(details);
  });
})();
